import { LicenseInfo } from '@mui/x-license-pro'
import log from 'loglevel'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './i18n'
import './index.css'
import { setGlobalLogLevel } from './utils'

LicenseInfo.setLicenseKey(
  '0c30cf0b99a163dbb409cac5c9010592Tz0xMTQ1NTQsRT0xNzgxMzk1MTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
)

// @ts-ignore
window.setLogLevel = log.setLevel
// @ts-ignore
window.logLevels = log.levels
// @ts-ignore
window.getLogLevel = log.getLevel

setGlobalLogLevel()
// @ts-ignore
window.Logger = log

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
